import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import AuthenticationContainer from 'containers/AuthenticationContainer';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components/macro';
import { createBrowserHistory } from 'history';

import { SignupConfirmationPage } from 'pages/SignupConfirmationPage';
import { SignupPage } from 'pages/SignUp';
import { LoginPage } from 'pages/Login';
import { DemoLoginPage } from 'pages/Login/DemoLoginPage';
import { ForgotPasswordPage } from 'pages/ForgotPassword';
import { ChangePasswordPage } from 'pages/ChangePassword';

import TeamProfileContainer from 'pages/TeamProfile/TeamProfileContainer';
import CommunityFeed from 'pages/CommunityMergeFeed/CommunityTabContainer';
import FooterContainer from 'containers/FooterContainer';
import PostShiftContainer from 'pages/PostShift/PostShiftContainer';
import SchedulerContainer from 'pages/Scheduler/SchedulerContainer';
import UserManagementContainer from 'pages/UserManagement/UserManagementContainer';
import SettingsContainer from 'pages/Settings/SettingsContainer';
import ScheduleTabContainer from 'pages/ScheduleTab/ScheduleTabContainer';
import RoleContainer from 'pages/Role/RoleContainer';

import { MainTheme, GlobalStyle } from '@shyft/acorns';
import { MqttProvider } from 'helpers/mqtt/MqttProvider';

import 'stylesheets/all.scss';
import 'stylesheets/App.scss';
import IntlContainer from './IntlContainer';
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import * as Sentry from "@sentry/react";

import mixpanel from 'mixpanel-browser';
import RequestsTabContainer from 'pages/RequestsTab/RequestsTabContainer';
import NavPanel from 'components/NavPanel/NavPanelContainer';
import HorizontalNavPanel from 'components/NavPanel/HorizontalNavPanelContainer';
import StartSignUpPage from 'pages/SignUp/StartSignUpPage';
import RegistrationProfilePage from 'pages/SignUp/RegistrationProfilePage';
import RegistrationLocationPage from 'pages/SignUp/RegistrationLocationPage';
import RegistrationAccountPage from 'pages/SignUp/RegistrationAccountPage';
import RegistrationLocationConfirmPage from 'pages/SignUp/RegistrationLocationConfirmPage';
import GoogleMapsLoader from './GoogleMapsLoader';
import RegistrationAccountVerificationPage from 'pages/SignUp/RegistrationAccountVerificationPage';
import UserNewsContainer from 'components/GeneralComponents/UserNewsModal/UserNewsContainer';

// Tour Components
import RouteTourManager from 'components/RouteTourManager/RouteTourManager';
import NavPanelTour from 'components/NavPanel/NavPanelTour';

const history = createBrowserHistory();
const showNavBar = false;
const mainBodyClassName = showNavBar ? 'main-body' : 'main-body-row';

// Route Configurations with routeProps
const publicRoutes = [
  { path: '/sign-up', component: StartSignUpPage, exact: true },
  { path: '/sign-up/profile', component: RegistrationProfilePage },
  { path: '/sign-up/location', component: RegistrationLocationPage },
  { path: '/sign-up/account', component: RegistrationAccountPage },
  { path: '/sign-up/verification', component: RegistrationAccountVerificationPage },
  { path: '/sign-up/confirm-location', component: RegistrationLocationConfirmPage },
  { path: '/users/confirmation', component: SignupConfirmationPage },
  { path: '/login', component: LoginPage},
  // { path: '/demologin', component: DemoLoginPage },
  { path: '/password-reset', component: ForgotPasswordPage },
  { path: '/users/password/edit', component: ChangePasswordPage },
];

const protectedRoutes = [
  { path: '/requests/:module', component: RequestsTabContainer },
  { path: '/post_shift', component: PostShiftContainer },
  { path: '/usermanagement', component: UserManagementContainer },
  { path: '/team/:id', component: TeamProfileContainer },
  { path: '/team/unreg/:id', component: TeamProfileContainer },
  { path: '/team-feed/:module', component: CommunityFeed },
  { path: '/scheduler', component: SchedulerContainer },
  { path: '/schedulecalendar', component: ScheduleTabContainer },
  { path: '/', component: ScheduleTabContainer, exact: true },
  { path: '/settings/:module', component: SettingsContainer },
  { path: '/roles', component: RoleContainer },
];

const App = ({ store }) => {
  return (
    <Sentry.ErrorBoundary fallback={<div>An error has occured.</div>}>
    <DndProvider backend={HTML5Backend}>
      <Provider store={store}>
        <MqttProvider>
          <ThemeProvider theme={MainTheme}>
            <IntlContainer>
              <GoogleMapsLoader>
                <Router>
                  <Switch>
                    {/* Public Routes */}
                    {publicRoutes.map(({ path, component, exact = false }) => (
                      <Route key={path} path={path} component={component} exact={exact} />
                    ))}

                    {/* Protected Routes with Authentication & routeProps */}
                    <>
                      <main className={mainBodyClassName}>
                        <GlobalStyle />
                        <HorizontalNavPanel history={history} />
                        <div className="content-wrapper">
                          <NavPanel history={history} />
                          <div className="main-content">
                            <Switch>

                              {protectedRoutes.map(({ path, component, exact = true }) => (
                                <AuthenticationContainer
                                  key={path}
                                  path={path}
                                  exact={exact}
                                  component={component}
                                  routeProps={{
                                    exact,
                                    path,
                                    component
                                  }}
                                />
                              ))}

                            </Switch>
                          </div>
                        </div>
                      </main>
                      <FooterContainer />
                    <UserNewsContainer />
                      {/* <RouteTourManager /> */}
                      {/* <NavPanelTour /> */}
                    </>
                  </Switch>
                </Router>
              </GoogleMapsLoader>
            </IntlContainer>
          </ThemeProvider>
        </MqttProvider>
      </Provider>
    </DndProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
